<template>
  <div class="portfolio-card" :title="app.name" role="button" tabindex="0">
    <!-- Thumbnail device mockup -->
    <div class="card-thumb">
      <div class="thumb-mockup" :class="deviceType">
        <!-- iPhone power button (right side) -->
        <span v-if="deviceType === 'mobile'" class="iphone-power-btn"></span>
        <!-- Mini browser chrome -->
        <div v-if="deviceType === 'browser'" class="thumb-chrome">
          <span class="td r"></span>
          <span class="td y"></span>
          <span class="td g"></span>
        </div>
        <!-- Mini desktop titlebar -->
        <div v-if="deviceType === 'desktop'" class="thumb-titlebar">
          <span class="td r"></span>
          <span class="td y"></span>
          <span class="td g"></span>
        </div>
        <!-- Screenshot or placeholder -->
        <img v-if="firstScreenshot" :src="firstScreenshot" :alt="app.name" class="thumb-img" />
        <div v-else class="thumb-placeholder">
          <v-icon :size="deviceType === 'mobile' ? 28 : 32" color="primary lighten-3">{{ placeholderIcon }}</v-icon>
        </div>
      </div>
      <!-- Active indicator bar -->
      <div class="card-active-bar"></div>
    </div>

    <!-- Card info -->
    <div class="card-info">
      <p class="card-name">{{ app.name }}</p>
      <v-chip x-small :color="categoryColor" outlined class="card-category-chip">
        {{ app.category }}
      </v-chip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppShowcaseCard',
  props: {
    app: { type: Object, required: true }
  },
  computed: {
    deviceType() {
      const platforms = (this.app.platforms || []).map(p => p.toLowerCase())
      if (platforms.some(p => ['web', 'website'].includes(p) || p.includes('web'))) return 'browser'
      if (platforms.some(p => ['windows', 'mac', 'macos', 'linux', 'desktop'].some(d => p.includes(d)))) return 'desktop'
      if (platforms.some(p => ['plugin', 'extension', 'chrome', 'vscode', 'wordpress', 'woocommerce', 'slack', 'erp', 'embeddable'].some(d => p.includes(d)))) return 'editor'
      return 'mobile'
    },
    firstScreenshot() {
      return this.app.screenshots && this.app.screenshots.length ? this.app.screenshots[0] : null
    },
    placeholderIcon() {
      return { mobile: 'mdi-cellphone', browser: 'mdi-web', desktop: 'mdi-monitor', editor: 'mdi-puzzle-outline' }[this.deviceType] || 'mdi-cellphone'
    },
    categoryColor() {
      const map = {
        'التجارة الإلكترونية': 'green',
        'الخدمات الصحية': 'red',
        'المطاعم والتوصيل': 'deep-orange',
        'التعليم الإلكتروني': 'purple',
        'الخدمات الحكومية': 'blue',
        'إدارة الأعمال': 'indigo',
        'المحاسبة والمالية': 'teal',
        'تكامل الأنظمة': 'orange',
        'تحليل البيانات': 'cyan',
        'E-commerce': 'green',
        'Health': 'red',
        'Education': 'purple',
        'Finance': 'teal',
        'Business': 'indigo'
      }
      return map[this.app.category] || 'secondary'
    }
  }
}
</script>

<style scoped lang="scss">
@import "./app-showcase-card-style.scss";
</style>